<fc-search-many-input
  [label]="'PENDENCY_TYPES.LABEL' | translate"
  [control]="control"
  [search]="search"
  [displayWith]="displayWith"
  tooltipPosition="above"
  [desiredStyle]="desiredStyle"
  [disabled]="disabled"
></fc-search-many-input>
